import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverCloseProps } from "./Popover.types";

export function PopoverClose({ ...props }: PopoverCloseProps): JSX.Element {
  return <BasePopover.Close data-slot="popover-close" {...props} />;
}
